<template>
  <div>
    <div id="select-full-page">
      <div id="main-margin">
        <div id="top-info">
          <div @click="$emit('close')">
            {{ $t('myday.cancel') }}
          </div>
          <span>{{ `${$t('form.select')}` }}</span>
        </div>
        <span class="form-title">{{ `${$t(label)}` }}</span>
        <RangeSlider
          :min="min"
          :max="max"
          :value="defaultValue"
          :disabled="false"
          @input="range = $event"
        />
        <button
          style="user-select: none"
          class="form-generator-button btn-custom"
          type="button"
          @click="validateRange()"
        >
          {{ $t('form.validate') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RangeSlider from '@/components/GenericComponents/RangeSlider.vue'
export default {
  components: { RangeSlider },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    defaultValue: {
      type: [Array, String, Object],
      default: null
    }
  },
  emits: ['close', 'dataSelected'],
  data() {
    return {
      range: this.defaultValue
    }
  },
  methods: {
    validateRange() {
      this.$emit('close')
      this.$emit('dataSelected', this.range)
    }
  }
}
</script>

<style lang="scss" scoped>
  #select-full-page {
    position: fixed;
    inset: 0;
    z-index: 200;
    background-color: #fff;

    #main-margin {
      margin: 10px 20px 0;

      > form {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      #top-info {
        margin-bottom: 7px;

        > div {
          position: absolute;
          width: 60px;
          z-index: 40;
          left: 20px;
          padding: 6px 6px 5px 0;
        }

        > span {
          width: 100%;
          font-size: 1.2rem !important;
          text-align: center;
          display: block;
          padding: 0 63px;
          line-height: 18px;
        }
      }

      #form-title {
        font-size: 20px;
      }
    }

    .query {
      border: 1px solid #b6b6b6;
      font-size: 0.9rem !important;
      -webkit-appearance: none;
      appearance: none;
      width: 100%;
      height: 33px;
      padding-left: 7px;
    }
  }
</style>
